import { useContext } from "react";
import { Helmet } from "react-helmet-async";
import batchesTranslations from "../locales/batchesTranslations";
import { LanguageContext } from "../locales/LanguageContext";

const Batches = () => { 
  const { lang } = useContext(LanguageContext);
  const t = batchesTranslations[lang] || {};
 

  return (
    <>
      <Helmet>
        <title>AKAAL KIDS | {t.pageTitle || "Batches"}</title>
      </Helmet>
      <div
        style={{
          width: "100%",
          background: "linear-gradient(90deg, #f6815e 0%, #f6b93b 100%)",
          color: "#fff",
          padding: "38px 0 24px 0",
          textAlign: "center",
          marginBottom: 32,
          boxShadow: "0 8px 32px #f6815e44",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <h1
          style={{
           fontWeight: 900,
            fontSize: "2.6rem",
            letterSpacing: 1,
            marginBottom: 11,
            textShadow: "0 2px 12px #f6815e55",
          }}
        >
          {t.pageTitle || "Batches"}
        </h1>
      </div>

      {/* batches content section starts  */}
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <p
              style={{
                fontSize: "1.25rem",
                color: "#555",
                lineHeight: "1.8",
                textAlign: "justify",
                marginBottom: 40,
                background: "#fffbe6",
                borderRadius: 12,
                boxShadow: "0 2px 12px #f6b93b22",
                padding: "18px 24px",
              }}
            >
              {t.intro}
              <br />
              <strong style={{ color: "#f6815e" }}>{t.admission}</strong>
            </p>

            <div
              className="card border-0 shadow-lg p-4 mb-5"
              style={{
                borderRadius: 22,
                background:
                  "linear-gradient(120deg, #fffbe6 0%, #f6b93b33 100%)",
                boxShadow: "0 6px 32px #f6b93b44",
              }}
            >
              <h3
                style={{
                  color: "#b26a00",
                  fontWeight: 900,
                  marginBottom: 20,
                  textAlign: "center",
                  fontSize: "2rem",
                  letterSpacing: 1,
                  textShadow: "0 2px 12px #f6b93b55",
                }}
              >
                {t.ageGroupHeading}
              </h3>
              <p style={{ fontSize: "1.15rem", color: "#444" }}>
                {t.ageGroupIntro}
              </p>
              <p style={{ fontSize: "1.15rem", color: "#444" }}>
                {t.developHeading}
              </p>
              <ul
                style={{
                  fontSize: "1.15rem",
                  color: "#444",
                  listStyle: "none",
                  paddingLeft: 0,
                  marginBottom: 0,
                }}
              >
                {(t.developPoints || []).map((item, idx) => (
                  <li
                    key={idx}
                    style={{
                      marginBottom: 10,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        color: "#f6815e",
                        marginRight: 10,
                        fontWeight: "bold",
                        fontSize: 22,
                      }}
                    >
                      ✓
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
              <p
                style={{
                  fontSize: "1.15rem",
                  color: "#444",
                  marginTop: 10,
                  fontStyle: "italic",
                }}
              >
                {t.youthNote}
              </p>
            </div>

            <div
              className="card border-0 shadow-lg p-4 mb-5"
              style={{
                borderRadius: 22,
                background:
                  "linear-gradient(120deg, #f6fafd 0%, #f6b93b11 100%)",
                boxShadow: "0 6px 32px #1976d244",
              }}
            >
              <h3
                style={{
                  color: "#1976d2",
                  fontWeight: 900,
                  marginBottom: 20,
                  textAlign: "center",
                  fontSize: "2rem",
                  letterSpacing: 1,
                  textShadow: "0 2px 12px #1976d255",
                }}
              >
                {t.levelsHeading}
              </h3>
              {(t.levels || []).map((level, idx) => (
                <div key={idx} style={{ marginBottom: 24 }}>
                  <h4
                    style={{
                      color: "#f6815e",
                      fontWeight: 700,
                      fontSize: "1.2rem",
                    }}
                  >
                    {level.title}
                  </h4>
                  <div style={{ color: "#444", marginBottom: 8 }}>
                    {level.desc}
                  </div>
                  <ul style={{ color: "#444", fontSize: 15, paddingLeft: 18 }}>
                    {(level.focus || []).map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div
              className="card border-0 shadow-lg p-4 mb-5"
              style={{
                borderRadius: 22,
                background:
                  "linear-gradient(120deg, #fffbe6 0%, #f6b93b33 100%)",
                boxShadow: "0 6px 32px #f6b93b44",
              }}
            >
              <h3
                style={{
                  color: "#b26a00",
                  fontWeight: 900,
                  marginBottom: 20,
                  textAlign: "center",
                  fontSize: "2rem",
                  letterSpacing: 1,
                  textShadow: "0 2px 12px #f6b93b55",
                }}
              >
                {t.structureHeading}
              </h3>
              <ul style={{ color: "#444", fontSize: 15, paddingLeft: 18 }}>
                {(t.structurePoints || []).map((point, idx) => (
                  <li key={idx}>{point}</li>
                ))}
              </ul>
            </div>

            <div
              className="card border-0 shadow-lg p-4 mb-5"
              style={{
                borderRadius: 22,
                background:
                  "linear-gradient(120deg, #f6fafd 0%, #f6b93b11 100%)",
                boxShadow: "0 6px 32px #1976d244",
              }}
            >
              <h3
                style={{
                  color: "#1976d2",
                  fontWeight: 900,
                  marginBottom: 20,
                  textAlign: "center",
                  fontSize: "2rem",
                  letterSpacing: 1,
                  textShadow: "0 2px 12px #1976d255",
                }}
              >
                {t.optionalHeading}
              </h3>
              <div style={{ color: "#444", marginBottom: 8 }}>
                {t.optionalIntro}
              </div>
              <ul style={{ color: "#444", fontSize: 15, paddingLeft: 18 }}>
                {(t.optionalPoints || []).map((point, idx) => (
                  <li key={idx}>{point}</li>
                ))}
              </ul>
            </div>

            <div
              className="card border-0 shadow-lg p-4 mb-5"
              style={{
                borderRadius: 22,
                background:
                  "linear-gradient(120deg, #fffbe6 0%, #f6b93b33 100%)",
                boxShadow: "0 6px 32px #f6b93b44",
              }}
            >
              <h3
                style={{
                  color: "#b26a00",
                  fontWeight: 900,
                  marginBottom: 20,
                  textAlign: "center",
                  fontSize: "2rem",
                  letterSpacing: 1,
                  textShadow: "0 2px 12px #f6b93b55",
                }}
              >
                {t.globalHeading}
              </h3>
              <div style={{ color: "#444", marginBottom: 8 }}>
                {t.globalIntro}
              </div>
              <ul style={{ color: "#444", fontSize: 15, paddingLeft: 18 }}>
                {(t.countries || []).map((country, idx) => (
                  <li key={idx}>{country}</li>
                ))}
                <li>{t.globalNote}</li>
              </ul>
            </div>

            <div
              className="card border-0 shadow-lg p-4 mb-5"
              style={{
                borderRadius: 22,
                background:
                  "linear-gradient(120deg, #f6fafd 0%, #f6b93b11 100%)",
                boxShadow: "0 6px 32px #1976d244",
              }}
            >
              <h3
                style={{
                  color: "#1976d2",
                  fontWeight: 900,
                  marginBottom: 20,
                  textAlign: "center",
                  fontSize: "2rem",
                  letterSpacing: 1,
                  textShadow: "0 2px 12px #1976d255",
                }}
              >
                {t.placementHeading}
              </h3>
              <ul style={{ color: "#444", fontSize: 15, paddingLeft: 18 }}>
                {(t.placementPoints || []).map((point, idx) => (
                  <li key={idx}>{point}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
     
    </>
  );
};

export default Batches;
